export class MyDateTime {
  static getCurrentDateTime(): string {
    const today = new Date();
    const date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
    return `${date} ${time}`;
  }
}

export class ErrorsView {
  row: number;
  column: number;
  message: string;
}

export class ResultSetError {
  type: number;
  mnemonic: string;
  resultset_id: number;
  balance: any;
  property: Property;
  errors: ErrorsView[];
}

export class Property {
  mnemonic: string;
  period: number;
  error_code: string;
  othermnemonic: string;
}

export class ActiveDetail {
  static row = 0;
  static col = 0;
  static last_change: string = null;
}

export class ActiveSummary {
  static row = 0;
  static col = 0;
  static last_change: string = null;
}

export class ActiveHighlights {
  static row = 0;
  static col = 0;
  static last_change: string = null;
}
export class MessageGenerator {
  public buildMessage(count: number, errorCode: string, account: string, propMnemonic: string, period: number, Mnemonic: string) {
    const message = period => {
      return `Property ${propMnemonic}, in account ${account}, for period ${period}`;
    };

    switch (errorCode) {
      case 'ValueCapError':
        return `${message(period)}, was capped to 0 due to it being a positive value`;
      case 'ValueFloorError':
        return `${message(period)}, was floored to 0 due to it being a negative value`;
      case 'PropertyForPeriod':
        return count === 1
          ? `${propMnemonic === 'EndBal' ? message(period - 1) : message(period)}, has no value for ${Mnemonic}`
          : `${message(period)}, has no value`;
      case 'NoAssumption':
        return `${message(period)}, has no associated assumption`;
      case 'NoNewVolumeBaseLine':
        return `${message(period)}, has no baseline value to be used in stress resultset`;
      case 'FundingImpactFloored':
        return `${message(period)}, Funding Impact was floored to 0 due to it being a negative value`;
      case 'WrongReferenceBalanceSheetAccount':
        return `${message(period)}, referenced account was not found in the Balance Sheet Chart of accounts`;
      default:
        return `${message(period)}, ${errorCode}`;
    }
  }
}

export class ActiveSelection {
  static row: number;
  static col: number;
  static last_change: string = null;
}

export class ActiveSummarySelection {
  static row: number;
  static col: number;
  static last_change: string = null;
}

export class ActiveHighlightsSelection {
  static row: number;
  static col: number;
  static last_change: string = null;
}
